var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWindowTips)?_c('div',{staticClass:"windows-tips",style:({opacity:_vm.isWindowTips?1:0})},[_c('div',{staticClass:"tips-content"},[_c('p',[_vm._v("Please Open In App")]),_c('p',[_c('button',{on:{"click":_vm.close}},[_vm._v("Ok")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }